jQuery( function ($) {

  if ( typeof gform != 'object' ) { return }


  $(document).on( 'gform_post_render', function ( e, form_id, current_page ) {
    observe_size( form_id )
  })


  const ro = new ResizeObserver( entries => {
    for ( let entry of entries ) {
      fill_columns( $( entry.target ) )
    }
  })


  function observe_size ( form_id ) {
    $( `form#gform_${ form_id }.two-col .gform_fields` ).each( function () {
      ro.observe( this )
    })
  }


  function sum_array ( arr ) {
    return arr.reduce( ( sum, x ) => sum + x, 0 )
  }


  function fill_columns ( $gfields ) {
    const container = $gfields.get(0)
    const $fields = $gfields.children( '.gfield' )
    const $textareas = $fields.filter( '.gfield--type-textarea' )

    $textareas.removeClass( 'fgrow' )

    const fcol = []
    const scol = $fields.get().map( el => el.getBoundingClientRect().height )
    
    while ( sum_array( fcol ) < sum_array( scol ) ) {
      fcol.push( scol.shift() )
    }

    $gfields.css( '--ch', `${ sum_array( fcol ) }px` )
    $textareas.addClass( 'fgrow' )

    const $slider = $gfields.closest( '.slick-slider' )
    if ( $slider.length ) {
      $slider.slick( 'setPosition' )
    }
  }

})